import { render, staticRenderFns } from "./MapMarkerIcon.vue?vue&type=template&id=689ed54c&"
import script from "./MapMarkerIcon.vue?vue&type=script&lang=ts&"
export * from "./MapMarkerIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports